package core.extensions

import common.EEnvironmentVariables
import kotlinx.browser.window

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 24.10.22
 * Author : marcusspors
 */
fun EEnvironmentVariables.getValue(): String {
    return window.asDynamic()[mVariableName] as String
}